<template>
    <div style="height: 100%">
        <div style="display: flex; width: 100%">
            <div style="width: 90%; height: 40px">
                <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
                    <el-input v-model="formDatas.auName" style="width: 180px;" size="mini" placeholder="姓名"
                        clearable></el-input>
                    <el-input v-model="formDatas.amcbPhone" style="width: 180px;" size="mini" placeholder="手机号"
                        clearable></el-input>
                    <el-input v-model="formDatas.amcbPhoneType" style="width: 180px;" size="mini" placeholder="运营商"
                        clearable></el-input>
                    <el-input v-model="formDatas.amcbStausDes" style="width: 180px;" size="mini" placeholder="状态描述"
                        clearable></el-input>
                    <!-- 所属年月 -->
                    <el-date-picker v-model="formDatas.amcbYearMonth" type="month" placeholder="所属年月" size="mini"
                        format="yyyy-MM" value-format="yyyyMM" style="width: 180px;" clearable
                        @change="partserch"></el-date-picker>
                    <el-select v-model="formDatas.amcbStaus" placeholder="状态" size="mini" style="width: 160px;"
                        @change="partserch" clearable>
                        <el-option label="待处理" :value="1"></el-option>
                        <el-option label="已发送" :value="2"></el-option>
                        <el-option label="发送失败" :value="3"></el-option>
                        <el-option label="已提交" :value="4"></el-option>
                        <el-option label="待修改" :value="5"></el-option>
                        <el-option label="已通过" :value="6"></el-option>
                    </el-select>
                    <el-select v-model="formDatas.amcbSendStatus" placeholder="发送状态" size="mini" style="width: 160px;"
                        @change="partserch" clearable>
                        <el-option label="否" :value="1"></el-option>
                        <el-option label="是" :value="2"></el-option>
                    </el-select>
                    <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                    <!-- <el-button type="primary" size="mini" style="margin-right: 10px;"
                        @click="bulkImport = true">批量导入</el-button> -->
                    <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button>
                    <el-button type="danger" size="mini" style="margin-left: 10px" @click="BulkRest">批量重新发送</el-button>
                    <el-button type="danger" size="mini" style="margin-left: 10px"
                        @click="BulkBillDate">批量编辑账单日期</el-button>
                </el-row>
            </div>
            <div style="width: 10%; height: 40px">
                <el-row style=" margin: 10px; width: 95%;display: flex; flex-direction: row-reverse;">
                    <el-button type="success" size="mini" style="margin-right: 20px" @click="BoxOpen">新增号码账单</el-button>
                    <el-button type="warning" size="mini" style="margin-right: 20px" @click="BoxOpenOutside">外部人员</el-button>

                    <!-- <el-button type="warning" size="mini" style="margin-right: 10px;" @click="Out()">导出</el-button> -->
                </el-row>
            </div>
        </div>
        <div class="tablemain">
            <div class="tablecss">
                <div style="width: 100%">
                    <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData"
                        :max-height="tableHight" :border-x="true" :border-y="true" :scrollWidth="10"
                        :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
                        row-key-field-name="amcbId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
                        :editOption="editOption" />
                    <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
                </div>
                <div class="table-pagination">
                    <ve-pagination :total="totalCount" :page-index="formDatas.currentPage"
                        :page-size="formDatas.pageSize" :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                        @on-page-number-change="pageNumberChange" @on-page-size-change="pageSizeChange" />
                </div>
            </div>
            <!-- 新增 -->
            <el-drawer :wrapperClosable="false" :title="edit == true ? '编辑号码账单' : '新增号码账单'" :before-close="handleClose"
                :visible.sync="dialog" direction="rtl" custom-class="demo-drawer" ref="drawer">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRef" :model="form" label-position="top" :rules="rules" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="用户" prop="auIds" v-if="!edit">
                                <el-radio-group v-model="isSbAsType">
                                    <el-radio label="0">选择花名册用户</el-radio>
                                    <el-radio label="1">上传文件</el-radio>
                                </el-radio-group>
                                <div v-if="isSbAsType == '0'" style="margin-top: 10px;">
                                    <el-select v-model="form.auIds" multiple filterable clearable placeholder="请选择用户"
                                        style="width: 80%;">
                                        <el-option v-for="item in getAjUserListSimple_data" :key="item.auId"
                                            :label="item.auName" :value="item.auId">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div v-if="isSbAsType == '1'" style="margin-top: 10px;">
                                    <el-upload class="upload-demo" action="#" accept=".xlsx,.xls"
                                        :on-change="updatabulk" :auto-upload="false" ref="bulk" multiple>
                                        <el-button size="medium" type="danger">点击上传</el-button>
                                    </el-upload>
                                    <div v-if="form.auIds.length > 0">已选择{{ form.auIds.length }}个用户</div>
                                    <div v-if="arrFail.length > 0">无效用户:</div>
                                    <el-table v-if="arrFail.length > 0" :data="arrFail" stripe border
                                        style="width: 100%" :max-height="300" :cell-style="{ textAlign: 'center' }"
                                        :header-cell-style="{
                                            textAlign: 'center',
                                            background: 'rgba(0,170,255,0.5)',
                                            color: 'black',
                                            border: 'none',
                                        }">
                                        <el-table-column prop="auName" label="姓名">
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </el-form-item>
                            <el-form-item label="所属年月" prop="amcbYearMonth">
                                <el-date-picker v-model="form.amcbYearMonth" type="month" placeholder="选择所属年月"
                                    value-format="yyyyMM">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="计划发送时间" prop="amcbSendTimePlan">
                                <el-date-picker v-model="form.amcbSendTimePlan" type="datetime" placeholder="选择计划发送时间"
                                    value-format="yyyyMMddHH">
                                </el-date-picker>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtn" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <!-- 新增外部人员账单 -->
            <el-drawer :wrapperClosable="false" title="新增外部人员账单" :before-close="handleOutsideClose"
                :visible.sync="dialogOutside" direction="rtl" custom-class="demo-drawer" ref="drawerOutside">
                <div class="demo-drawer__content" style="height: 90%;">
                    <el-form ref="formRefOutside" :model="formOutside" label-position="top" :rules="rulesOutside" style="height:100%">
                        <div
                            style="width: 100%;height: 100%; overflow-y: scroll;padding: 50px 50px 15px;overflow-x: hidden;">
                            <el-form-item label="用户名" prop="auName">
                                <el-input v-model="formOutside.auName" style="width: 80%;" placeholder="请输入用户名"></el-input>
                            </el-form-item>
                            <el-form-item label="所属年月" prop="amcbYearMonth">
                                <el-date-picker v-model="formOutside.amcbYearMonth" type="month" placeholder="选择所属年月"
                                    value-format="yyyyMM" style="width: 80%;">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="计划发送时间" prop="amcbSendTimePlan">
                                <el-date-picker v-model="formOutside.amcbSendTimePlan" type="datetime" placeholder="选择计划发送时间"
                                    value-format="yyyyMMddHH" style="width: 80%;">
                                </el-date-picker>
                            </el-form-item>
                        </div>
                    </el-form>
                </div>
                <div class="demo-drawer__footer" style="margin-top: 10px;">
                    <el-button @click="handleOutsideClose()" style="margin-left: 20%;">取 消</el-button>
                    <el-button type="primary" @click="SureBtnOutside" style="margin-left: 150px;">
                        确 定</el-button>
                </div>
            </el-drawer>
            <!-- 发送记录详情 -->
            <el-dialog title="发送记录详情" :visible.sync="diaDetail" width="80%" :before-close="diaDetailClose"
                style="margin-left: 200px;">
                <el-row style="margin: 10px auto; width: 95%; display: flex; padding-left: 20px">
                    <el-select v-model="formMsg.fdumsStatus" placeholder="发送状态" size="mini" @change="partserchDetail"
                        style="width: 120px;" clearable>
                        <el-option label="成功" :value="1"></el-option>
                        <el-option label="失败" :value="2"></el-option>
                    </el-select>
                    <!-- <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
                        style="margin-left: 10px">搜索</el-button>
                   -->
                </el-row>
                <div>
                    <ve-table :columns="columnsDetail" :table-data="tableDataDetail" :max-height="500" :border-x="true"
                        :border-y="true" :scrollWidth="10" row-key-field-name="dataIndex"
                        :cell-style-option="cellStyleOption" style="width: 100%" />
                    <div v-show="tableDataDetail.length == 0" class="empty-data">暂无数据</div>
                    <div class="table-pagination">
                        <ve-pagination :total="totalCountMsg" :page-index="formMsg.currentPage"
                            :page-size="formMsg.pageSize"
                            :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
                            @on-page-number-change="pageNumberChange2" @on-page-size-change="pageSizeChange2" />
                    </div>
                </div>
            </el-dialog>
            <el-dialog title="编辑号卡账单" :visible.sync="isCardBill" width="70%" top="8vh">
                <el-form ref="formRef2" :model="formBill" label-position="left" :rules="rules" style="height:40vh"
                    label-width="150px" size="small">
                    <div
                        style="width: 100%;height: 100%; overflow-y: scroll;padding: 20px 50px 15px;overflow-x: hidden;">
                        <el-form-item label="手机号" prop="amcbPhone">
                            <el-input v-model="formBill.amcbPhone" style="width: 80%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="运营商" prop="amcbPhoneType">
                            <el-input v-model="formBill.amcbPhoneType" style="width: 80%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="金额" prop="amcbMoney">
                            <el-input v-model="formBill.amcbMoney" style="width: 80%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="特殊备注" prop="amcbDes">
                            <el-input v-model="formBill.amcbDes" style="width: 80%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="入职时间" prop="auDateEntry">
                            <el-date-picker v-model="formBill.auDateEntry" style="width: 80%;" type="date"
                                placeholder="请选择日期"></el-date-picker>
                        </el-form-item>
                        <el-form-item label="人员状态" prop="auStatus">
                            <el-input v-model="formBill.auStatus" style="width: 80%;" placeholder="请输入"></el-input>
                        </el-form-item>
                        <el-form-item label="话费截图" prop="amcbImages">
                            <my-upload ref="Imgupload" @fileChange="fileChange" :filearr.sync="fileList" :limit="99"
                                @removeAfter="removeAfter" style="margin: 10px 5px 5px;">
                            </my-upload>
                            <!-- <el-input v-model="form.aaFiles" style="width: 80%;" disabled placeholder="请先上传"></el-input> -->
                        </el-form-item>
                    </div>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="handleBillClose">取 消</el-button>
                    <el-button type="primary" @click="SureBtnBill">确 定</el-button>
                </span>
            </el-dialog>
            
        </div>
    </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
import config from '../../api/env.js';
import {
    updateAjMobileCardBillSendRepeat, deleteAjMobileCardBill, getFxxkDingUserMsgSendList, getAjUserListSimple, updateFxxkDingUserMsgCancel, getAjMobileCardBillList,
    addAjMobileCardBill, addAjMobileCardBillOutside, updateFxxkDingUserMsg, uploadAjUserReturnIdsList, updateAjMobileCardBillCheck, updateAjMobileCardBill, updateAjMobileCardBillAdmin
} from "../../api/api";
export default {
    name: "",
    components: {},
    data() {
        return {
            fileList: [],
            formBill: {
                amcbImages: [],
            },
            isCardBill: false,
            arrFail: [],
            isSbAsType: '0',
            bulkImport: false,
            columnsDetail: [
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    align: "center",
                    fixed: 'left',
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "name",
                    key: "name",
                    title: "用户名",
                    align: "center",
                    edit: false,
                },
                {
                    field: "fdumsStatus",
                    key: "fdumsStatus",
                    title: "发送状态",
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row.fdumsStatus === 1 ? <el-tag size="mini" type="success">成功</el-tag> :
                                        row.fdumsStatus === 2 ? <el-tag size="mini" type="danger">失败</el-tag> :
                                            <el-tag size="mini" type="default">未知</el-tag>
                                }
                            </span>
                        );
                    },
                },
                {
                    field: "fdumsStatusDes",
                    key: "fdumsStatusDes",
                    title: "状态备注",
                    align: "center",
                    edit: false,
                },
                {
                    field: "createtime",
                    key: "createtime",
                    title: "创建时间",
                    align: "center",
                    edit: false,
                    width: 140,
                },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 160,
                    align: "center",
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>


                                {
                                    row.fdumsStatus == 2 ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.handleRest(row)}
                                    >
                                        重新发送
                                    </el-button> : ''
                                }

                            </span>
                        );
                    },
                },
            ],
            bulkData: [],

            getAjUserListSimple_data: [],
            theRow: {},
            form2: {},
            diaAddReturn: false,
            diaDetail: false,
            tableDataDetail: [],
            dialogStatusValue: '',
            dialogStatus: false,
            key: 'amcbId',
            dialog: false,
            edit: false,
            form: {
                auIds: []
            },
            rules: {},
            dialogOutside: false,
            formOutside: {
                auName: '',
                amcbYearMonth: '',
                amcbSendTimePlan: '',
            },
            rulesOutside: {
                auName: [{ required: true, message: "请输入用户名", trigger: "blur" }],
                amcbYearMonth: [{ required: true, message: "请选择所属年月", trigger: "change" }],
                amcbSendTimePlan: [{ required: true, message: "请选择计划发送时间", trigger: "change" }],
            },
            // 未编辑前的值
            lastValue: "",
            // 单元格编辑功能
            editOption: {
                beforeCellValueChange: ({ row, column, changeValue }) => {
                    this.beforeCellValChange(row, column, changeValue);
                },
                afterCellValueChange: ({ row, column, changeValue }) => {
                    this.afterCellValChange(row, column, changeValue);
                },
            },
            cellSelectionOption: {
                // disble cell selection
                enable: true,
            },
            totalCount: 100,
            totalCountMsg: 100,
            pageIndex: 1,
            pageSize: 10,
            selectedRowKeysCollection: [],
            checkboxOption: {
                // 可控属性
                selectedRowKeys: [],
                // 行选择改变事件
                selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
                    this.changeSelectedRowKeys(row, isSelected, this.key);
                },
                // 全选改变事件
                selectedAllChange: ({ isSelected, selectedRowKeys }) => {
                    this.changeSelectAll(isSelected, selectedRowKeys, this.key);
                },
            },
            cellStyleOption: {
                headerCellClass: ({ column, rowIndex }) => {
                    if (rowIndex === 0) {
                        return "table-header-cell-class";
                    }
                },
            },
            windheight: "",
            tableHight: 520,

            columns: [
                {
                    field: "",
                    key: "checkbox",
                    // type=checkbox
                    type: "checkbox",
                    fixed: 'left',
                    title: "",
                    width: 50,
                    align: "center",
                },
                {
                    field: "",
                    key: "a",
                    title: "序号",
                    width: 50,
                    fixed: 'left',
                    align: "center",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return ++rowIndex;
                    },
                },
                {
                    field: "auName",
                    key: "auName",
                    title: "姓名",
                    align: "center",
                    width: 120,
                    edit: false,
                },
                {
                    field: "auDateEntry",
                    key: "auDateEntry",
                    title: "入职时间",
                    align: "center",
                    width: 130,
                    edit: false,
                },
                {
                    field: "auStatus",
                    key: "auStatus",
                    title: "人员状态",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "amcbPhone",
                    key: "amcbPhone",
                    title: "手机号",
                    align: "center",
                    width: 150,
                    edit: false,
                },
                {
                    field: "amcbPhoneType",
                    key: "amcbPhoneType",
                    title: "运营商",
                    align: "center",
                    width: 110,
                    edit: false,
                }, {
                    field: "amcbYearMonthStr",
                    key: "amcbYearMonthStr",
                    title: "所属年月",
                    align: "center",
                    width: 110,
                    edit: false,
                },

                {
                    field: "amcbSendTimePlanStr",
                    key: "amcbSendTimePlanStr",
                    title: "计划发送时间",
                    align: "center",
                    width: 150,
                    edit: false,
                },
                {
                    field: "amcbMoney",
                    key: "amcbMoney",
                    title: "话费金额",
                    align: "center",
                    width: 100,
                    edit: false,
                },
                {
                    field: "amcbImages",
                    key: "amcbImages",
                    title: "话费截图",
                    align: "center",
                    edit: false,
                    width: 350,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span style="display:flex;align-items: center;">
                                <div style="width:80%;">
                                    {
                                        row.amcbImages ? (JSON.parse(row.amcbImages || [])).map((item) => {
                                            return <el-image ref="scrImg" id="scrimg" src={item} alt="" fit="fill" style="width: 80px;height: 50px;"
                                                previewSrcList={JSON.parse(row.amcbImages || [])}></el-image>
                                        }) : <span></span>
                                    }

                                </div>
                            </span>

                        );
                    },
                },
                {
                    field: "amcbDes",
                    key: "amcbDes",
                    title: "特殊备注",
                    align: "center",
                    width: 160,
                    edit: false,
                },
                {
                    field: "amcbStausDes",
                    key: "amcbStausDes",
                    title: "状态描述",
                    align: "center",
                    width: 160,
                    edit: false,
                },

                {
                    field: "amcbStaus",
                    key: "amcbStaus",
                    title: "状态",
                    align: "center",
                    fixed: "right",
                    width: 90,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.amcbStaus == 1 ? <el-tag>待处理</el-tag>
                            : row.amcbStaus == 2 ? <el-tag type="success">已发送</el-tag>
                                : row.amcbStaus == 3 ? <el-tag type="danger">发送失败</el-tag>
                                    : row.amcbStaus == 4 ? <el-tag type="primary">已提交</el-tag>
                                        : row.amcbStaus == 5 ? <el-tag type="warning">待修改</el-tag>
                                            : <el-tag type="success">已通过</el-tag>;
                    },
                },
                {
                    field: "amcbSendStatus",
                    key: "amcbSendStatus",
                    title: "发送状态",
                    fixed: "right",
                    align: "center",
                    width: 90,
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return row.amcbSendStatus == 1 ? <el-tag type="danger">未发送</el-tag>
                            : row.amcbSendStatus == 2 ? <el-tag type="success">已发送</el-tag>
                                : '';
                    },
                },
                { field: "amcbiTimeSubmit", key: "amcbiTimeSubmit", title: "提交时间", width: 160, align: "center" },
                { field: "createtime", key: "c", title: "创建时间", width: 160, align: "center" },
                {
                    field: "",
                    key: "d",
                    title: "操作",
                    width: 220,
                    align: "center",
                    fixed: "right",
                    renderBodyCell: ({ row, column, rowIndex }, h) => {
                        return (
                            <span>
                                {
                                    row ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.handleDelete(row)}
                                    >
                                        删除
                                    </el-button> : ''
                                }
                                {
                                    row.amcbStaus == 4 ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color: green"
                                        on-click={() => this.handleUp(row)}
                                    >
                                        通过审核
                                    </el-button> : ''
                                }
                                {
                                    row.amcbStaus == 4 ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color: red"
                                        on-click={() => this.handleDown(row)}
                                    >
                                        驳回审核
                                    </el-button> : ''
                                }
                                {
                                    row ? <el-button
                                        size="mini"
                                        type="text"
                                        style="color: green"
                                        on-click={() => this.handleEdit(row)}
                                    >
                                        编辑
                                    </el-button> : ''
                                }

                            </span>
                        );
                    },
                },
            ], //表格的列
            tableData: [],
            post: null,
            formMsg: {
                currentPage: 1,
                pageSize: 20,
            },
            formDatas: {
                dmDelete: 1,
                currentPage: 1,
                pageSize: 10,
            },

            bulkDataCopy: [],
            sitId: '',
            importData: {},

        };
    },
    activated() {
        this.watchFlag = true;
        this.$nextTick(() => {
            this.windheight = this.$store.state.windheight;
            this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        });
    },
    watch: {
        "$store.state.windheight"(val) {
            this.$nextTick(() => {
                if (this.watchFlag) {
                    this.tableHight = val - 200 - val * 0.04;
                }
            });
        },
    },
    deactivated() {
        this.watchFlag = false;
    },
    created() {
        this.windheight = this.$store.state.windheight
        this.tableHight = this.windheight - 200 - this.windheight * 0.04;
        getAjUserListSimple({ pageSize: 0, checkStatus: 2 }).then(res => {
            this.getAjUserListSimple_data = res.data
        })
        this.getList();
    },
    mounted() { },
    methods: {
        SureBtnBill() {
            this.$confirm("是否确定要新增, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.openLoading()
                    const newForm = JSON.parse(JSON.stringify(this.formBill))
                    newForm.amcbImages = newForm.amcbImages ? JSON.stringify(newForm.amcbImages) : '';
                    newForm.amcbSubmit = 2
                    updateAjMobileCardBillAdmin(newForm).then(res => {
                        this.loadings.close()
                        if (res.status == 200) {
                            this.$message({
                                type: "success",
                                message: "成功!",
                            });

                            this.handleBillClose()
                            this.getList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleBillClose() {
            this.$refs['formRef2'].resetFields();
            this.$refs.Imgupload.fileAllRemove()
            this.fileList = [];
            this.isCardBill = false;
        },
        // 上传图片
        fileChange(file) {
            if (this.formBill.amcbImages && this.formBill.amcbImages.length > 0) {
                console.log(file);

                file.forEach((item, index) => {
                    this.formBill.amcbImages.push(item)
                })

            } else {
                this.$set(this.formBill, 'amcbImages', file)
            }
            this.$message({
                type: "success",
                message: "上传成功!",
            });
        },
        removeAfter(file) {
            const url = this.formBill.amcbImages.findIndex(item => item === file)
            this.formBill.amcbImages.splice(url, 1)
        },
        BulkBillDate() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
                return
            }
            this.edit = true;
            this.dialog = true;
        },
        diaDetailClose() {
            this.diaDetail = false;
        },
        pageSizeChange2(pageSize) {
            this.formMsg.pageSize = pageSize;
            this.partserchDetail();
        },
        pageNumberChange2(pageIndex) {
            console.log(pageIndex);
            this.formMsg.currentPage = pageIndex;
            getFxxkDingUserMsgSendList(this.formMsg).then(res => {
                this.tableDataDetail = res.data;
                this.totalCountMsg = res.total;
            })
        },
        partserchDetail() {
            this.formMsg.currentPage = 1;
            getFxxkDingUserMsgSendList(this.formMsg).then(res => {
                this.tableDataDetail = res.data;
                this.totalCountMsg = res.total;
            })
        },
        handleDetail(row) {
            this.formMsg.amcbId = row.amcbId;
            this.partserchDetail();
            this.diaDetail = true;
        },
        handleRest(row) {
            this.$confirm("是否确定要重新发送吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateAjMobileCardBillSendRepeat({ amcbIds: row.amcbId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "重新发送成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleDown(row) {
            this.$confirm("是否确定要暂停吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    updateFxxkDingUserMsgCancel({ amcbId: row.amcbId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "暂停成功!",
                            });

                            this.getList()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleUp(row) {
            this.$prompt("请输入审核备注?", "确定要审核通过吗", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then((value) => {
                    console.log(value)
                    updateAjMobileCardBillCheck({ amcbId: row.amcbId, amcbStaus: 6, amcbStausDes: value.value }).then(res => {
                        this.$message({
                            type: "success",
                            message: "审核成功!",
                        });
                        this.getList()
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleDown(row) {
            this.$prompt("请输入审核备注?", "确定要驳回吗", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then((value) => {
                    console.log(value)
                    updateAjMobileCardBillCheck({ amcbId: row.amcbId, amcbStaus: 5, amcbStausDes: value.value }).then(res => {
                        this.$message({
                            type: "success",
                            message: "审核成功!",
                        });
                        this.getList()
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        downloadFile(url, name) {//下载
            if (!url) {
                return
            }
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.onload = function () {
                document.body.removeChild(link);
            };
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
        },
        async updatabulk(file, fileList) {
            console.log(file, fileList);
            this.form.auIds = [];
            this.arrFail = []
            let Data = new FormData();
            Data.append('file', file.raw)
            this.openLoading()
            uploadAjUserReturnIdsList(Data).then(res => {
                if (res.data.length == 0) {
                    this.$message({
                        showClose: true,
                        message: "上传失败，请检查文件内容",
                        type: 'danger'
                    });
                    this.loadings.close()
                    return
                }
                this.loadings.close()
                res.data.forEach((item, index) => {
                    if (item.auId) {
                        this.form.auIds.push(item.auId)
                    } else {
                        this.arrFail.push(item)
                    }
                })
            })
        },
        bulkImportClose(done) {
            done();
            this.bulkData = [];
            this.$nextTick(() => {
                this.getList()
            })
        },
        openLoading() {
            //loading请求等待
            this.loadings = this.$loading({
                lock: true,
                text: "加载中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
        },
        Out() {
            var s = qs.stringify(this.formDatas);
            this.openLoading()
            var that = this
            axios({
                method: 'post',
                url: config.baseURL + '/aj-mobile-card-bill/exportAjMobileCardBill',
                data: s,
                // withCredentials: true,
                timeout: 1200000,
                responseType: 'arraybuffer',
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                    'userid': window.localStorage.getItem('userid')
                }
            }).then(function (res) {
                if (res.data) {
                    that.loadings.close()
                    let a = document.createElement('a');
                    //ArrayBuffer 转为 Blob
                    let blob = new Blob([res.data], {
                        type: "application/vnd.ms-excel"
                    });
                    let objectUrl = URL.createObjectURL(blob);
                    a.setAttribute("href", objectUrl);
                    a.setAttribute("download", '号码账单.xlsx');
                    a.click();
                    that.$message({
                        message: "成功",
                        type: "success"
                    });

                }
            })
        },
        bulkImportClick() {
            if (this.sitId == '') {
                this.$message({
                    showClose: true,
                    message: "请导入资料",
                    type: 'danger'
                });
            } else {
                uploadImportAjAssetsKey({
                    sitId: this.sitId
                }).then(res => {
                    this.getList()
                    this.bulkImport = false;
                    this.bulkData = [];
                    this.bulkDataCopy = [];
                    this.sitId = '';
                    this.$refs['bulk'].clearFiles()
                    this.$message({
                        type: 'success',
                        message: '导入成功!'
                    });
                })
            }

        },

        handleStatus(row) {
            this.theRow = row;
            this.dialogStatusValue = row.aakStatus;
            this.dialogStatus = true;
        },
        sureStatus() {
            updateAjAssetsFireEquipmentStatus({ amcbId: this.theRow.amcbId, aakStatus: this.dialogStatusValue }).then(res => {
                if (res.data) {
                    this.$message({
                        type: "success",
                        message: "修改成功!",
                    });
                    this.getList();
                    this.dialogStatusValue = ''
                }
            })
            this.dialogStatus = false;
        },
        closeStatus() {
            this.dialogStatus = false;
            this.dialogStatusValue = ''
        },
        // 批量重新发送
        BulkRest() {
            if (this.selectedRowKeysCollection.length == 0) {
                this.$message({
                    showClose: true,
                    message: "请选择",
                    type: 'danger'
                });
            } else if (this.selectedRowKeysCollection.length > 0) {
                this.$confirm("是否确定吗, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        updateAjMobileCardBillSendRepeat({ amcbIds: JSON.stringify(this.selectedRowKeysCollection) }).then(res => {
                            this.$message({
                                type: "success",
                                message: "成功!",
                            });
                            this.checkboxOption.selectedRowKeys = [];
                            this.selectedRowKeysCollection = [];
                            this.partserch()
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }
        },

        handleDelete(row) {
            this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    deleteAjMobileCardBill({ amcbId: row.amcbId }).then(res => {
                        if (res.data) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });

                            this.partserch()
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                })
        },
        handleEdit(row) {
            const data = JSON.parse(JSON.stringify(row))
            this.isCardBill = true;
            this.$nextTick(() => {
                data.amcbImages = data.amcbImages ? JSON.parse(data.amcbImages) : [];
                if (data.amcbImages.length > 0) {
                    data.amcbImages.forEach((item, index) => {
                        const img = {
                            name: item,
                            url: item,
                        }
                        this.$set(this.fileList, index, img)
                    })
                }
                this.formBill = data;
            })
        },
        SureBtn() {
            if (!this.edit) {
                this.$confirm("是否确定要新增, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        this.openLoading()
                        const newForm = JSON.parse(JSON.stringify(this.form))
                        newForm.auIds = newForm.auIds ? JSON.stringify(newForm.auIds) : '';
                        addAjMobileCardBill(newForm).then(res => {
                            this.loadings.close()
                            if (res.status == 200) {
                                this.$message({
                                    type: "success",
                                    message: "发布成功!",
                                });

                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            } else {
                this.$confirm("是否确定要编辑, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        this.openLoading()
                        const newForm = JSON.parse(JSON.stringify(this.form))
                        newForm.amcbIds = this.selectedRowKeysCollection ? JSON.stringify(this.selectedRowKeysCollection) : '';
                        updateAjMobileCardBill(newForm).then(res => {
                            this.loadings.close()
                            if (res.status == 200) {
                                this.$message({
                                    type: "success",
                                    message: "编辑成功!",
                                });
                                this.checkboxOption.selectedRowKeys = [];
                                this.selectedRowKeysCollection = [];
                                this.handleClose()
                                this.getList()
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消",
                        });
                    })
            }

        },
        BoxOpen() {
            this.dialog = true;

        },
        // 关闭弹框
        handleClose() {
            this.dialog = false;
            this.edit = false;
            this.$refs['formRef'].resetFields();
            this.arrFail = [];
        },
        // 打开外部人员账单弹窗
        BoxOpenOutside() {
            // 重置表单数据
            this.formOutside = {
                auName: '',
                amcbYearMonth: '',
                amcbSendTimePlan: '',
            };
            this.dialogOutside = true;
        },
        // 关闭外部人员账单弹窗
        handleOutsideClose() {
            this.dialogOutside = false;
        },
        // 确认新增外部人员账单
        SureBtnOutside() {
            if (!this.$refs.formRefOutside) {
                this.$message.error("表单初始化失败，请重试");
                return;
            }
            this.$refs.formRefOutside.validate((valid) => {
                if (valid) {
                    this.$confirm("是否确定要新增外部人员账单, 是否继续?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    })
                        .then(() => {
                            this.openLoading()
                            const newForm = JSON.parse(JSON.stringify(this.formOutside))
                            addAjMobileCardBillOutside(newForm).then(res => {
                                this.loadings.close()
                                if (res.status == 200) {
                                    this.$message({
                                        type: "success",
                                        message: "新增成功!",
                                    });
                                    this.handleOutsideClose()
                                    this.getList()
                                }
                            })
                        }).catch(() => {
                            this.$message({
                                type: "info",
                                message: "已取消",
                            });
                        })
                }
            });
        },

        // 修改单元格
        async beforeCellValChange(row, column, changeValue) {
            if (row[column.field] == changeValue) {
                return false;
            }

            this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    var jsonObj = {};
                    let formData = new FormData();
                    formData.append(column.field, changeValue);
                    formData.forEach((value, key) => (jsonObj[key] = value));
                    jsonObj.amcbId = row.amcbId
                    console.log(jsonObj);
                    updateFxxkDingUserMsg(jsonObj).then(res => {
                        this.$message({
                            type: "success",
                            message: "编辑成功!",
                        });
                    })

                })
                .catch(() => {
                    this.lastValue = row[column.field];
                    this.$nextTick(() => {
                        this.tableData.forEach((item) => {
                            for (let key in item) {
                                if (key == column.field && item[key] == changeValue) {
                                    item[key] = this.lastValue;
                                }
                                console.log(key);
                            }
                        });
                    });
                    this.$message({
                        type: "info",
                        message: "已取消编辑",
                    });
                    return false;
                });
        },
        afterCellValChange(row, column, changeValue) {
            // console.log(" afterCellValChange", row, column, changeValue);
        },
        // reset selectedRowKeys
        resetSelectedRowKeys(key) {

            this.checkboxOption.selectedRowKeys = [];

            const selectedRowKeysCollection = this.selectedRowKeysCollection;

            if (selectedRowKeysCollection.length) {
                this.tableData.forEach((item) => {
                    if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        console.log(item);
                        this.checkboxOption.selectedRowKeys.push(item[key]);
                    }
                });
            }
        },
        // select all change
        changeSelectAll(isSelected, selectedRowKeys, key) {

            this.checkboxOption.selectedRowKeys = selectedRowKeys;

            if (isSelected) {
                this.selectedRowKeysCollection = this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
            } else {
                this.tableData.forEach((item, index) => {
                    if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
                        this.selectedRowKeysCollection.splice(this.selectedRowKeysCollection.indexOf(item[key]), 1);
                    }
                });
            }
        },
        changeSelectedRowKeys(row, isSelected, key) {

            const rowKey = row[key];

            if (isSelected) {
                this.checkboxOption.selectedRowKeys.push(rowKey);
                this.selectedRowKeysCollection.push(rowKey);
                console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
            } else {
                const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
                this.checkboxOption.selectedRowKeys.splice(index, 1);
                this.selectedRowKeysCollection.splice(index, 1);
            }
        },
        pageSizeChange(pageSize) {
            this.formDatas.pageSize = pageSize;
            this.partserch();
        },
        pageNumberChange(pageIndex) {
            console.log(pageIndex);
            this.formDatas.currentPage = pageIndex;
            getAjMobileCardBillList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });

        },
        partserch() {
            this.formDatas.currentPage = 1;
            getAjMobileCardBillList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
                this.resetSelectedRowKeys(this.key);
                // this.$message({
                //   type: "success",
                //   message: "搜索成功!",
                // });
            });
        },
        getList() {
            getAjMobileCardBillList(this.formDatas).then((res) => {
                this.tableData = res.data;
                this.totalCount = res.total;
            });
        },
    },
};
</script>

<style>
.table-header-cell-class {
    background: var(--bg-color) !important;
    color: var(--font-color) !important;
    border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
    display: none;
}

.ve-table-container {
    height: auto !important;
}
</style>